import React, { useState } from 'react';
import PowerupsInfoModal from './PowerupsInfoModal';
import './PowerupsInfoButton.css';

export default function PowerupsInfoButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="powerups-info-button"
        onClick={() => setOpen(true)}
        aria-label="Powerups help"
        title="Powerups help"
      >
        ?
      </button>
      {open && <PowerupsInfoModal onClose={() => setOpen(false)} />}
    </>
  );
}

